export const canUseSubtitleFormat = (hasClaim, format, allSubtitlesAllowed) => {
    const claimFormat = format === 'srt_FB' ? 'srt' : format;
    const hasFormatClaim = hasClaim(`subtitles:${claimFormat}`);
    // NOTE: stl_apa must always be explicitly granted.
    if (format === 'stl_apa') {
        return hasFormatClaim;
    }
    return allSubtitlesAllowed || hasFormatClaim;
};
